(function(){
  function init(root){
    if(root.dataset.altHomeReady)return;
    root.dataset.altHomeReady='true';
    var filters=Array.from(root.querySelectorAll('[data-alt-home-filter]'));
    var cards=Array.from(root.querySelectorAll('[data-alt-home-group]'));
    filters.forEach(function(button){button.addEventListener('click',function(){
      var group=button.dataset.altHomeFilter;
      filters.forEach(function(filter){filter.setAttribute('aria-pressed',String(filter===button));});
      cards.forEach(function(card){card.hidden=card.dataset.altHomeGroup!==group;});
    });});
    root.querySelectorAll('.altair-home-products__card').forEach(function(card){
      var swatches=Array.from(card.querySelectorAll('[data-alt-home-swatch]'));
      swatches.forEach(function(button){button.addEventListener('click',function(){
        var image=card.querySelector('[data-alt-home-image]');
        var link=card.querySelector('[data-alt-home-link]');
        var label=card.querySelector('[data-alt-home-color]');
        if(image){image.srcset=button.dataset.srcset||'';image.src=button.dataset.image;image.alt=link.querySelector('h3').textContent+' – '+button.dataset.color;}
        if(link&&button.dataset.url)link.href=button.dataset.url;
        if(label)label.textContent=button.dataset.color;
        swatches.forEach(function(swatch){swatch.setAttribute('aria-pressed',String(swatch===button));});
      });});
    });
  }
  function scan(container){container.querySelectorAll('[data-alt-home-products]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){scan(document);});
  else scan(document);
  document.addEventListener('shopify:section:load',function(event){scan(event.target);});
})();
